<div class="footer-menu">
  <div *ngFor="let item of footerItems" #nav (click)="navigateToRoute(item.route)">

    <div class="footer-item clickable" 
      [ngClass]="{'footer-item-selected': isFooterItemSelected(item)}"
      [ngStyle]="{'width': (100 / footerItems.length) + '%'}">
      <mat-icon class="footer-item-icon" matBadgeSize="small" matBadge="{{ item.badgeValue }}">{{ item.iconName }}</mat-icon>
      <p class="footer-item-title">{{ item.displayNameTranslation | translate }}</p>
    </div>

  </div>
</div>